import { CmsSectionShell } from './CmsSectionShell.tsx';
import { CmsSectionState } from './CmsSectionState.tsx';
import { themeOf } from './cmsTheme.ts';
import { ScheduleBlock } from './ScheduleSection.tsx';
import { useFestivalData } from '../../lib/festivalData.ts';
import type { TimetableSection } from '../../lib/types.ts';

/**
 * Wraps the existing schedule/timetable rendering (ScheduleBlock, shared with
 * the bespoke /program page) in the standard CMS theme/guitar shell. Always
 * fed from DataContext (schedule.json / program.json) — the section carries
 * no authored body.
 *
 * Sets id="tidsplan" so TopNav's hardcoded "Tidsplan" nav item
 * (/program#tidsplan) keeps scrolling to this section (CMS-034).
 */
export function CmsTimetableSection({ theme, guitar }: TimetableSection) {
  const t = themeOf(theme);
  const { data, loading, error } = useFestivalData();

  return (
    <CmsSectionShell theme={theme} guitar={guitar} id="tidsplan">
      <CmsSectionState
        loading={loading}
        error={!!error}
        loadingLabel="Indlæser tidsplan…"
        bodyClass={t.body}
        errorMessage="Tidsplanen kunne ikke indlæses."
      >
        {data && <ScheduleBlock data={data} theme={theme} />}
      </CmsSectionState>
    </CmsSectionShell>
  );
}
